app.directive('filterSearchPage', function (debounce, $rootScope, $http, $q, $compile, $document, $log) {
    return {
        restrict: 'A',
        scope: {
            submitUrl: '@filterSearchPage',
            pageNumberFieldName: '@pageNumberField'
        },
        controller: function ($scope) {
            $scope.filterSearchPage = {
                hasMoreResults: false,
                currentPage: 1,
                currentPromise: null
            };

            if (isMobile.phone) {
                $scope.hideSidebar = true;
            } else {
                $scope.hideSidebar = false;
            }
        },
        link: function ($scope, $element) {
            var $filterForm = $element.find('form');
            var $loader = $element.find('.sg-filter-search-page-spinner');
            var $resetButton = $element.find('.sg-filter-search-page-reset-filters');
            var $filterButton = $element.find('.filter-sidebar-btn');
            var $itemsContainer = $document.find('#to-repl');
            var $loadMoreButton = $document.find('.sg-filter-search-page-btn-loadmore-container > a');
            var $sideFilterQueryStr = '';
            var $sideFilterStringify = '';
            var methods = {
                getFormData: function() {
                    return $filterForm.serialize();
                },
                getNextPageFormData: function() {
                    return $filterForm.serialize() + '&' + encodeURIComponent($scope.pageNumberFieldName) + '=' + (Number($scope.filterSearchPage.currentPage)+1);
                },
                handleResponse: function(httpResponse, append) {
                    $scope.filterSearchPage.hasMoreResults = httpResponse.data.hasMoreResults;
                    $scope.filterSearchPage.currentPage = httpResponse.data.pageNumber;

                    var newElements = $compile(httpResponse.data.html)($scope.$parent);


                    if(!append) {
                        $itemsContainer.empty();
                    }

                    $itemsContainer.append(newElements);
                },
                applyNewFilters: function() {
                    var nonEmptyFilters = $filterForm.serializeArray().filter(function(item, index) {
                        return item.name !== $scope.pageNumberFieldName && item.value !== "";
                    });

                    // if ($sideFilterQueryStr) {
                    //     var nonEmptySidebarFilters = $sideFilterQueryStr.filter(function(item, index) {
                    //         return item.value !== "";
                    //     });

                    //     Array.prototype.push.apply(nonEmptyFilters, nonEmptySidebarFilters);
                    //     console.log(nonEmptyFilters);
                    // }

                    // Push the state to the url so we can use the browser's back functionnality
                    // and automatically search based on the query string parameters.
                    var search = document.location.search;
                    var url = document.location.pathname + (Object.keys(nonEmptyFilters).length === 0 ? '' : ('?' + jQuery.param(nonEmptyFilters)));
                    history.replaceState(nonEmptyFilters, null, url);

                    methods.fetchData(methods.getFormData(), false);
                },
                fetchNextPage: function() {
                    methods.fetchData(methods.getNextPageFormData(), true);
                },
                fetchData: function(formData, append) {
                    if($scope.filterSearchPage.currentPromise !== null) {
                        $scope.filterSearchPage.currentPromise.resolve();
                        $scope.filterSearchPage.currentPromise = null;
                    }

                    var canceller = $q.defer();

                    $http({
                        method: 'POST',
                        url: $scope.submitUrl,
                        data: formData + '&' + $sideFilterStringify,
                        responseType: 'json',
                        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                        timeout: canceller.promise
                    }).then(function(httpResponse) {
                        $scope.filterSearchPage.currentPromise = null;
                        methods.handleResponse(httpResponse, append);
                    }, function(httpError) {
                        $scope.filterSearchPage.currentPromise = null;
                        if(httpError.xhrStatus !== "abort") {
                            $log.error(httpError);
                        }
                    });

                    $scope.filterSearchPage.currentPromise = canceller;
                },
                clearAllFilters: function() {
                    $filterForm.find('input, select').each(function(index, item) {
                        if (item.type === 'checkbox') {
                            item.checked = false;
                        } else if (item.type === 'text' || item.tagName.toLowerCase() === 'select') {
                            $(item).val('');
                        }
                    });
                    methods.applyNewFilters();
                }
            };

            // here need to receive data.
            $scope.$on('sidebarSearchData', function (event, data) {
                // console.log(data);
                if (data.hasOwnProperty('queryString')) {
                    $sideFilterQueryStr = data.queryString;
                    $sideFilterStringify = 'sideFilter=' + data.postData;
                    methods.applyNewFilters();
                } else {
                    $sideFilterQueryStr = '';
                    $sideFilterStringify = '';
                    methods.applyNewFilters();
                }
            });

            // Bind Watchers and events
            $scope.$watch('filterSearchPage.currentPromise', function (newValue) {
                if (newValue) {
                    $loader.removeClass('invisible');
                } else {
                    $loader.addClass('invisible');
                }
            });

            $scope.filterSearchPage.hasMoreResults = !$loadMoreButton.hasClass('d-none');
            $scope.$watch('filterSearchPage.hasMoreResults', function (newValue) {
                if (newValue) {
                    $loadMoreButton.removeClass('d-none');
                } else {
                    $loadMoreButton.addClass('d-none');
                }
            });

            $filterForm.find('select, input[type=checkbox]').on('change', debounce(500, false, function($event) {
                $scope.$apply(function() {
                    methods.applyNewFilters();
                });
            }));

            $filterForm.find('input').on('keydown keyup', debounce(500, false, function($event) {
                $scope.$apply(function() {
                    methods.applyNewFilters();
                });
            }));

            $filterForm.on('submit',function($event) {
                $event.preventDefault();

                $scope.$apply(function() {
                    methods.applyNewFilters();
                });
            });

            $loadMoreButton.on('click', function($event) {
                $event.preventDefault();

                $scope.$apply(function() {
                    if($loadMoreButton.is(':hidden') || $scope.filterSearchPage.currentPromise !== null) {
                        return;
                    }

                    methods.fetchNextPage();
                });
            });

            $resetButton.on('click', function($event) {
                $event.preventDefault();

                $scope.$apply(function() {
                    methods.clearAllFilters();
                });
            });


            $filterButton.on('click', function($event) {
                $scope.$apply(function() {
                    $scope.hideSidebar = ! $scope.hideSidebar;
                    $rootScope.$broadcast('hideSidebar', $scope.hideSidebar);
                });
            });

        }
    };
});
